"use client"

import { useState } from 'react'
import SvgIcon from '@components/shared/svg-icons/SvgIcon'
import mix from '@utils/styles/mix'

import styles from './Messages.module.css'

const CAR = <svg aria-hidden="true" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="2.4" viewBox="0 0 120 48"><path d="M8 38v-9q2-5 11-6l18-2 13-11q3-2 9-2h29q6 0 8 5l5 12q3 1 3 6v7z" /><circle cx="30" cy="38" r="7.5" /><circle cx="90" cy="38" r="7.5" /></svg>
const SYS = { dat: 'doc', packet: 'pause', admin: 'bell' }

// Miniatura: zdjęcie ogłoszenia (zakończone / usunięte — przygaszone), logo firmy (zapytanie z wizytówki), rozmowa bez
// ogłoszenia, wiadomość systemowa.
export default function Thumb ({ offer, salon, system }) {
    const [broken, setBroken] = useState(false)
    if (system) return <span aria-hidden="true" className={mix([styles.thumb, styles.thumbSys])}><SvgIcon name={SYS[system] || 'bell'} /></span>
    if (salon) {
        return (
            <span aria-hidden="true" className={mix([styles.thumb, styles.thumbLogo])}>
                { salon.logo && !broken ? <img alt="" loading="lazy" onError={() => setBroken(true)} src={salon.logo} /> : <SvgIcon name="building" /> }
            </span>
        )
    }
    if (!offer) return <span aria-hidden="true" className={mix([styles.thumb, styles.thumbNone])}><SvgIcon name="chat" /></span>
    const dim = offer.state && offer.state !== 'active'
    return (
        <span aria-hidden="true" className={mix([styles.thumb, dim && styles.thumbDim])}>
            { offer.photo && !broken ? <img alt="" loading="lazy" onError={() => setBroken(true)} src={offer.photo} /> : CAR }
        </span>
    )
}
